import React from 'react'

import FieldHelp from "../../../gd-components/help-and-hint/field-help/field-help"
import FieldProto from "../../../fields3/proto/field-proto"
import FormFieldError from "../../common/form-error/form-field-error"
import FormModel from "../../common/form-model-manager"

type Props = {

    field?              : FieldProto    // now mandatory
    form?               : FormModel // | FormManager - support only formModel !

    label?              : any         // can be string or component !!!
    labelClass?         : string
    labelStyle?         : any

    width?              : number | string

    description?        : string | null

    className?          : string

    elementClass?       : string
    subElementClasses?  : string
    errorClass?         : string
    // type?: 'default' | 'text' | 'text-multiline'
    onDelete?           : callback

    fieldHelp?          : string,       // field help/hint message

    children?           : any

    noMargin?           : boolean
}

export default function FormRowFlex(props:Props) {


    let fieldHelp = props.fieldHelp || props.field?.description
    // if (!fieldHelp && props.field && props.field.description) {
    //     fieldHelp = props.field.description
    // }

    const label = props.label || props.field?.label

    // STREMNO - nado proverit' vezde ... :(
    // const description = props.description || props.field?.description
    const description = props.description

    const labelStyle = props.labelStyle || {
        width       : _.get(props,'width', 150) + 'px',
        minWidth    : _.get(props,'width', 150) + 'px', // flex svoloch'...
    }
    const labelClass = props.labelClass ? props.labelClass : 'ui5-txt-not-important m-r-20 h-36 flex-row-left-center'

    const elementClasses = Classes("flex-column-left-top", props.elementClass, {})
    const subElementClasses = Classes("flex-row-left-center", props.subElementClasses, {
        'max-w-100p': !props.subElementClasses?.includes('w-')
    })

    const classes = Classes("ui5-form-flex-row flex-row-left-top", props.className, {
        'm-b-20'        : !props.noMargin && !props.className?.includes('m-b-')
    })

    return (
        <div className={classes}>
            <div className  = {labelClass}
                 style      = {labelStyle}
            >
                {label}
            </div>

            <div className={elementClasses}>
                <div className={subElementClasses}>
                    {props.onDelete &&
                        <div className="ui5-field-with-delete-on-hover">
                            {props.children}
                            <div className  = "ui5-ico-trash red s-14"
                                 onClick    = {props.onDelete}
                            />
                        </div>}

                    {!props.onDelete &&
                        props.children}

                    {fieldHelp &&
                        <FieldHelp
                            className   = "m-l-10"
                            message     = {fieldHelp}
                        />}
                </div>

                {props.field && props.form &&
                    <FormFieldError
                        className   = {props.errorClass}
                        form        = {props.form}
                        field       = {props.field}
                    />}

                {description &&
                    <div className="ui5-txt-not-important-small m-t-5 lh-14em">{description}</div>}
            </div>
        </div>
    )
}
